import React, { useState, useEffect } from "react";

import { Image } from "antd";
import { addIcon, editIcon, homeIcon, redTrash } from "../../assets";
import { Table } from "antd";
import LegalDocModal from "../../components/legalDocModal/LegalDocModal";
import Loader from "../../components/loader/loader";
import PageHeader from "../../components/pageHeader/PageHeader";
import { useDispatch } from "react-redux";
import { productItem } from "../../redux/userDataSlice";
import moment from "moment/moment";
import { RedNotify } from "../../helper/helper";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

const documentConfig = {
  title: "About Us",
  field: "aboutUs",
  collectionName: "legal_documents",
};

const documentTypes = {
  PRIVACY_POLICY: {
    id: "0",
    title: "Privacy Policy",
    field: "policy",
    collectionName: "legal_documents",
  },
  TERMS_CONDITIONS: {
    id: "1",
    title: "Terms & Conditions",
    field: "terms",
    collectionName: "legal_documents",
  },
  ABOUT_US: {
    id: "1",
    title: "About Us",
    field: "aboutUs",
    collectionName: "legal_documents",
  },
};
const FAQs = (documentType = "ABOUT_US") => {
  const dispatch = useDispatch();
  const [isloading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState();
  const [addProduct, setAddProduct] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const getDescriptionText = (htmlString) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || "";
  };

  const [document, setDocument] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, "legal_documents"));

      if (querySnapshot.empty) {
        console.log(`No  document found.`);
        RedNotify(`No document found.`);
        return;
      }

      const docs = querySnapshot.docs.map((doc) => ({
        _id: doc.id,
        ...doc.data(),
      }));

      console.log(docs);
      setDocuments(docs);
      setDocument(docs[0]); // Use the first document
    } catch (error) {
      console.error(`Error fetching:`, error);
      RedNotify(error.message);
    } finally {
      setLoading(false);
    }
  };
  const currentDocConfig = documentTypes[documentType];
  useEffect(() => {
    fetchDocuments();
  }, []);
  const handleEditClick = () => {
    setShowModal(true);
  };
  const tableItems = document
    ? [
        {
          key: document.id,
          content: document[documentConfig.field] || "",
        },
      ]
    : [];

  const columns = [
    {
      title: "Description",
      dataIndex: "content",
      align: "center",
      className: "action-column-header",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          className="terms-content"
        />
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      align: "center",
      className: "action-column-header",
      render: () => (
        <div onClick={handleEditClick} className="edit-icon-container">
          <img src={editIcon} alt="Edit" />
        </div>
      ),
    },
  ];

  useEffect(() => {}, [showModal]);

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";
  };

  return (
    <div className="admin-products-main-container">
      {showModal && (
        <LegalDocModal
          showModal={showModal}
          setShowModal={setShowModal}
          item={document}
          id={"0"}
          refreshData={fetchDocuments} // Pass the refresh function
        />
      )}
      <Loader loading={loading} />
      <PageHeader
        eyebrow="Content"
        title="About Us"
        subtitle="The About content surfaced to users in the 2nd Home app. Use the edit action to update it."
      />
      <div className="server-roles-tb-main-container">
        <Table
          columns={columns}
          dataSource={tableItems}
          pagination={false}
          className="terms-table"
          rowKey="key"
        />
      </div>
    </div>
  );
};

export default FAQs;
